var map = {
	"./01-login.jpg": 680,
	"./02-login.jpg": 681,
	"./03-login.jpg": 682,
	"./04-login.jpg": 683,
	"./05-login.jpg": 684
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 679;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.jpg$
// module id = 679
// module chunks = 0